import React, { useContext, useEffect, useState } from "react";
import ReactDOM from "react";
import WebServiceContext from "../../webService/WebServiceContext";
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, scales, } from 'chart.js';
import { Bar } from 'react-chartjs-2';

import { Loading } from "../SVG";

ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    scales
);


const money = (value: number) => {
    var formatter = new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 0,
    });
    return formatter.format(value)
}

const labels: string[] = ["一月", "二月", "三月", "四月", "五月", "六月"]

type GoldSkyChatProps = {
    currentYear:number
}

const GoldSkyChat = (props:GoldSkyChatProps) => {
    const ws = useContext(WebServiceContext)
    const [isLoading, setIsLoading] = useState<boolean>(true)

    const [valueLifes, setValueLifes] = useState<number[]>([])
    const [valueProps, setValueProps] = useState<number[]>([])
    
    const [ggsPer, setGgsPer] = useState<number>(0)
    
    useEffect(() => {
        setIsLoading(true)
        ws.webservice.asyncPerformance("44008_天勤獎", props.currentYear).then((res: any) => {
            //console.log(res)
            setIsLoading(false)
            if (res.length > 0) {
                setValueLifes([
                    parseInt(res[0]['壽險1件數']?res[0]['壽險1件數']:0),
                    parseInt(res[0]['壽險2件數']?res[0]['壽險2件數']:0),
                    parseInt(res[0]['壽險3件數']?res[0]['壽險3件數']:0),
                    parseInt(res[0]['壽險4件數']?res[0]['壽險4件數']:0),
                    parseInt(res[0]['壽險5件數']?res[0]['壽險5件數']:0),
                    parseInt(res[0]['壽險6件數']?res[0]['壽險6件數']:0)
                ])
                setValueProps([
                    parseInt(res[0]['產專1件']?res[0]['產專1件']:0),
                    parseInt(res[0]['產專2件']?res[0]['產專2件']:0),
                    parseInt(res[0]['產專3件']?res[0]['產專3件']:0),
                    parseInt(res[0]['產專4件']?res[0]['產專4件']:0),
                    parseInt(res[0]['產專5件']?res[0]['產專5件']:0),
                    parseInt(res[0]['產專6件']?res[0]['產專6件']:0)
                ])

                setGgsPer(res[0]['產險發薪業績']+res[0]['壽險發薪業績'])
            }
        })
        return
    }, [props.currentYear])


    if (isLoading) {
        return (<Loading />)
    } else {
        return (
            <>
            <div className="card-short">
                總件數:<span className="value">{

                   valueLifes.length >0 && valueProps.length > 0 &&
                   (
                        valueLifes.reduce((a:number,b:number)=>a+b)+
                        valueProps.reduce((a:number,b:number)=>a+b)
                   )
                }</span>
                總業績：<span className="value">{money(ggsPer)}</span>
            </div>
            <div className="BarChatBox card-content" >
                <div className="card-mesg">
                    總件數:<span className="value">{
                        valueLifes.length >0 && valueProps.length > 0 &&
                        (
                            valueLifes.reduce((a:number,b:number)=>a+b)+
                            valueProps.reduce((a:number,b:number)=>a+b)
                        )
                    }</span>
                    總業績：<span className="value">{money(ggsPer)}</span>
                </div>
                <Bar
                    height={160}
                    data={{
                        labels: labels,
                        datasets: [
                            {
                                data: [
                                    valueLifes[0],
                                    valueLifes[1],
                                    valueLifes[2],
                                    valueLifes[3],
                                    valueLifes[4],
                                    valueLifes[5]
                                ],
                                label: "壽險",
                                backgroundColor: 'rgba(180, 220, 100, 1)',
                                borderColor: 'rgba(180, 220, 100, 1)',
                                borderWidth: 2
                            },
                            {
                                data: [
                                    valueProps[0],
                                    valueProps[1],
                                    valueProps[2],
                                    valueProps[3],
                                    valueProps[4],
                                    valueProps[5]
                                ],
                                label: '產險',
                                backgroundColor: "rgba(80, 190, 220, 1)",
                                borderColor: 'rgba(180, 220, 100, 1)',
                                borderWidth: 2
                            },

                        ]
                    }}
                    options={{
                        indexAxis: 'y' as const,
                        scales: {
                            x: {
                                stacked: true,
                                min: 0,
                                //max: 200,
                                ticks: {
                                    callback: (value): string => {
                                        const _v: number = value as number;
                                        return _v.toString() + "件";
                                    }
                                }
                            },
                            y: {
                                stacked: true,
                                ticks: {
                                    callback: (value, index, values): string => {
                                        return `${labels[index].toString()}共(${valueLifes[index]+valueProps[index]})件`;
                                    }
                                }
                            }
                        },
                        elements: {
                            bar: {
                                borderWidth: 2,
                            },
                        },
                        responsive: true,
                        maintainAspectRatio : true,
                        plugins: {
                            legend: {
                                //display: false
                            },
                            tooltip: {
                                enabled: false
                            }
                        }
                    }}
                />
            </div>
            </>
        )
    }
};

export default GoldSkyChat